import React, { useState, useEffect,useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
//import { useAction } from 'convex/react';
//import { api } from './convex/_generated/api';
import { toast } from 'sonner';
import { ShieldCheck, Loader2, ArrowRight, Copy, CheckCheck,Mail } from 'lucide-react';
//import { QRCodeSVG } from 'qrcode.react';
import axios from "axios";

export default function MFASetup() {
  const [secret, setSecret] = useState('');
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.state?.userId;
  const email = location.state?.email;
  const hasRun = useRef(false);

  //const enableMFA = useAction(api.mfa.enableMFA);
  //const sendOTP = useAction(api.mfa.sendOTP);
   

  //useEffect(() => {
    //if (!userId) {
      //navigate('/');
      //return;
    //}
    //if (hasRun.current) return; // ← stop second call
      //  hasRun.current = true;
    //const setup = async () => {
      //try {
      //  console.log("user");
      //  console.log(userId);
       // const s = await enableMFA({ userId });
        //setSecret(s);
      //} catch (err) {
        //if (err.message === 'MFA already enabled') {
          // already set up — go straight to verify
          //navigate('/mfa-verify', { state: { userId } });
          //console.log(err.message)
        //} else {
          //toast.error(err.message || 'Failed to set up MFA');
          //navigate('/');
        //}
      //} finally {
        //setLoading(false);
      //}
    //};
    //setup();
  //}, [secret]);

  useEffect(() => {
    //if (!userId) { navigate('/'); return; }
    if (hasRun.current) return;
    hasRun.current = true;

    const setup = async () => {
      try {
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/send-otp`, { userId: userId, email,});
        toast.success(`Code sent to ${email}`);
      } catch (err) {
        if (err.message === 'MFA already enabled') {
          // already set up — go straight to verify
          navigate('/mfa-verify', { state: { userId, email } });
          //console.log(err.message)
        } else {
          toast.error(err.message || 'Failed to set up MFA');
          //navigate('/');
        }
      } finally {
        setLoading(false);
      }
    };
    setup();
  }, []);

  const qrUrl = secret
    ? `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=otpauth://totp/MyApp:${userId}?secret=${secret}%26issuer=MyApp`
    : '';

  const handleCopy = () => {
    navigator.clipboard.writeText(secret);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

   return (
    <div style={styles.page}>
      <div style={styles.glow1} />
      <div style={styles.glow2} />

      <div style={styles.card}>
        <div style={styles.iconWrap}>
          <Mail size={28} color="#fff" />
        </div>

        <h1 style={styles.title}>Check your email</h1>
        <p style={styles.subtitle}>
          We sent a 6-digit code to <strong style={{ color: '#fff' }}>{email}</strong>. 
          Enter it on the next screen.
        </p>

        {loading ? (
          <div style={styles.center}>
            <Loader2 size={32} style={styles.spin} />
          </div>
        ) : (
          <button
            onClick={() => navigate('/mfa-verify', { state: { userId, email } })}
            style={styles.btn}
          >
            Enter code <ArrowRight size={18} />
          </button>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0f0c29, #302b63, #24243e)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    position: 'relative',
    overflow: 'hidden',
    fontFamily: "'DM Sans', sans-serif",
  },
  glow1: {
    position: 'absolute',
    top: -100,
    right: -100,
    width: 400,
    height: 400,
    background: 'rgba(124, 58, 237, 0.3)',
    borderRadius: '50%',
    filter: 'blur(120px)',
    pointerEvents: 'none',
  },
  glow2: {
    position: 'absolute',
    bottom: -100,
    left: -100,
    width: 400,
    height: 400,
    background: 'rgba(74, 222, 128, 0.15)',
    borderRadius: '50%',
    filter: 'blur(120px)',
    pointerEvents: 'none',
  },
  card: {
    background: 'rgba(255,255,255,0.05)',
    backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 24,
    padding: '40px 36px',
    width: '100%',
    maxWidth: 420,
    position: 'relative',
    zIndex: 1,
    textAlign: 'center',
  },
  iconWrap: {
    width: 56,
    height: 56,
    borderRadius: 16,
    background: 'linear-gradient(135deg, #7c3aed, #4ade80)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 20px',
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    color: '#fff',
    margin: '0 0 10px',
    letterSpacing: '-0.5px',
  },
  subtitle: {
    fontSize: 14,
    color: 'rgba(255,255,255,0.55)',
    lineHeight: 1.6,
    margin: '0 0 28px',
  },
  btn: {
    width: '100%',
    background: 'linear-gradient(90deg, #7c3aed, #4ade80)',
    color: '#fff',
    border: 'none',
    borderRadius: 12,
    padding: '14px 20px',
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    padding: 40,
  },
  spin: {
    animation: 'spin 1s linear infinite',
  },
};
